import { Link } from "react-router-dom";

export const M_LOGO_URL = "https://customer-assets.emergentagent.com/job_myservicehelper/artifacts/uo18h5or_officielle%20MyServiceHelper-logo.png";
export const FULL_LOGO_URL = "https://customer-assets.emergentagent.com/job_myservicehelper/artifacts/uo18h5or_officielle%20MyServiceHelper-logo.png";

// M-mark used inside the workflow diagram (centre logo on home page)
export const LogoMark = ({ size = 36, className = "", animated = false }) => (
    <img
        src={M_LOGO_URL}
        alt="MyServiceHelper"
        className={`inline-block select-none drop-shadow-[0_4px_18px_rgba(37,99,235,0.25)] ${animated ? "float-soft" : ""} ${className}`}
        style={{ width: size, height: size, objectFit: "contain" }}
        loading="eager"
        draggable={false}
    />
);

// Kept for backwards compat in spots that explicitly want the styled text
export const LogoText = ({ className = "" }) => (
    <span className={`font-bold tracking-tight ${className}`}>
        <span className="text-slate-900">My</span>
        <span className="text-blue-600">Service</span>
        <span className="text-slate-900">Helper</span>
    </span>
);

// Primary header / sidebar / auth-page logo: the full official logo image (contains the name + gradient line + checkmark)
export const Logo = ({ to = "/", height = 30, className = "" }) => (
    <Link
        to={to}
        data-testid="site-logo-link"
        className={`inline-flex items-center group ${className}`}
        aria-label="MyServiceHelper forside"
    >
        <img
            src={FULL_LOGO_URL}
            alt="MyServiceHelper"
            style={{ height }}
            className="w-auto object-contain select-none group-hover:opacity-90 transition-opacity"
            draggable={false}
        />
    </Link>
);

export default Logo;
